import type { IMixpanelClient, IHotjarClient, ILaunchDarklyClient } from '@Shared';


let hostRouter: any | null = null;
let basePath: string | null = null;
let mixpanelClient: IMixpanelClient | null = null;
let hotjarClient: IHotjarClient | null = null;
let launchDarklyClient: ILaunchDarklyClient | null = null;
let highRiskCountries: string[] = [];

export const init = ({ router, basePath: base, mixpanelClient: mixpanel, hotjarClient: hotjar, launchDarklyClient: ld = null, highRiskCountries: highRisk = [] }: {
    router: any;
    basePath: string;
    mixpanelClient: IMixpanelClient;
    hotjarClient: IHotjarClient;
    launchDarklyClient?: ILaunchDarklyClient | null;
    highRiskCountries?: string[];
}) => {
    console.log('MFE Auth Config initialized');
    hostRouter = router;
    basePath = base;
    mixpanelClient = mixpanel || null;
    hotjarClient = hotjar || null;
    launchDarklyClient = ld || null;
    // Copy so later mutation of the host-owned array can't change this module's config.
    highRiskCountries = Array.isArray(highRisk) ? [...highRisk] : [];
};

export const getHostRouter = () => hostRouter;
export const getBasePath = () => basePath;
export const getMixpanelClient = (): IMixpanelClient | null => mixpanelClient;
export const getHotjarClient = (): IHotjarClient | null => hotjarClient;
export const getLaunchDarklyClient = (): ILaunchDarklyClient | null => launchDarklyClient;
// Return a shallow copy so callers can't mutate global config (e.g. sort/push).
export const getHighRiskCountries = (): string[] => [...highRiskCountries];

export default {
    init,
    getHostRouter,
    getBasePath,
    getMixpanelClient,
    getHighRiskCountries
};
